import React, { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import { IonButton } from '@ionic/react';
import classNames from 'classnames';

type HeaderEndSlotBtnProps = ComponentPropsWithoutRef<typeof IonButton> & {} & PropsWithChildren;

const HeaderEndSlotBtn = ({ className, children, ...rest }: HeaderEndSlotBtnProps) => {
  return (
    <IonButton
      className={classNames(
        'min-h-none [&::part(native)]:p-0 m-0 [&::part(native)]:text-brand-primary [&::part(native)]:text-base',
        className,
      )}
      slot="end"
      fill="clear"
      color="light"
      {...rest}
    >
      {children}
    </IonButton>
  );
};

export default HeaderEndSlotBtn;
